<template>
    <div class="fixed inset-0 overflow-y-auto" :class="{ 'z-10': show, 'z-neg': ! show }">
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <transition
                enter-active-class="ease-out duration-300"
                enter-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="ease-in duration-200"
                leave-class="opacity-100"
                leave-to-class="opacity-0">
                <div v-show="show" class="fixed inset-0 transition-opacity" aria-hidden="true">
                    <div class="absolute inset-0 bg-gray-500 opacity-65"></div>
                </div>
            </transition>
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
            <transition
                enter-active-class="ease-out duration-300"
                enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                leave-active-class="ease-in duration-200"
                leave-class="opacity-100 translate-y-0 sm:scale-100"
                leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <div v-show="modalShown" class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <form v-if="! sent" method="POST">
                        <div class="mb-5">
                            <div :class="`mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-${$root.theme}-100`">
                                <svg :class="`h-8 w-8 text-${$root.theme}-600`" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                                </svg>
                            </div>
                            <div class="mt-2">
                                <h3 class="text-lg leading-6 font-medium text-gray-900 text-center" id="modal-headline">
                                    Send Payment Receipt
                                </h3>
                                <p class="mb-4 text-sm font-medium text-center">Provide your updated e-mail address and mobile phone number to receive the receipt.</p>

                                <label for="email" class="block font-semibold text-gray-700 mb-2">
                                    Email
                                </label>
                                <input v-model="email"
                                   type="text"
                                   name="email"
                                   id="email"
                                   :class="`py-3 px-4 rounded bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 relative block w-full rounded-md bg-transparent focus:z-10 sm:text-sm border-gray-300`"
                                   placeholder="Your email">
                                <span v-if="emailError" class="block text-xs text-red-500 mt-1" v-text="emailError" />
                                <span v-else-if="emailError === false" class="block text-xs text-green-500 mt-1">That email address is valid.</span>
                            </div>
                        </div>
                        <div  class="sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                            <button @click.prevent="saveEmail" :class="{
                                [`w-full inline-flex text-black items-center justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-${$root.theme}-300 text-base font-medium hover:bg-${$root.theme}-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-500 sm:col-start-2 sm:text-sm`]: true,
                            }" class="">
                                <i v-if="loading" class="fa fa-spinner fa-spin text-black"></i>
                                <template v-else>Send</template>
                            </button>
                            <button @click="close" type="button" :class="`mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-500 sm:mt-0 sm:col-start-1 sm:text-sm`">
                                Nevermind
                            </button>
                        </div>
                    </form>
                    <form v-else method="POST">
                        <div class="mb-5">
                            <div :class="`mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-${$root.theme}-100`">
                                <svg :class="`h-8 w-8 text-${$root.theme}-600`" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                                </svg>
                            </div>
                            <div class="mt-2">
                                <h3 class="text-lg leading-6 font-medium text-gray-900 text-center" id="modal-headline">
                                    Send Payment Receipt
                                </h3>
                                <p class="mb-4 mt-4 mt-2 text-sm font-medium text-green-600 text-center">Email receipt was sent.</p>
                                <p class="mb-2 text-sm font-medium text-center">Is this your best contact email address?</p>
                                <p class="mb-4 text-base font-medium text-center">{{ email }}</p>
                            </div>
                        </div>
                        <div  class="sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                            <button @click.prevent="markAsPrimary" :class="{
                                [`w-full inline-flex text-black items-center justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-${$root.theme}-300 text-base font-medium hover:bg-${$root.theme}-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-500 sm:col-start-2 sm:text-sm`]: true,
                            }">
                                <i v-if="loading" class="fa fa-spinner fa-spin text-black"></i>
                                <template v-else>Yes</template>
                            </button>
                            <button @click="close" type="button" :class="`mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-500 sm:mt-0 sm:col-start-1 sm:text-sm`">
                                No thank you
                            </button>
                        </div>
                    </form>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import validatesAndSavesContactInformation from "../../mixins/validatesAndSavesContactInformation";

    export default {
        mixins: [validatesAndSavesContactInformation],

        props: ['show', 'account', 'payment'],

        mounted() {
            if (this.account.hasOwnProperty('email')) {
                this.email = this.account.email;
            }

            if (this.show && ! this.modalShown) {
                this.modalShown = true;
            }
        },

        watch: {
            show(show, oldShow) {
                if (show && ! oldShow) {
                    this.modalShown = true;
                }
            }
        },

        data() {
            return {
                sent: false,
                modalShown: false,
                emailRequired: true,
                resetEmail: false,
                emailAddressStatus: 'added',
            };
        },

        methods: {
            done() {
                this.$http
                    .post(`${this.$root.$refs.app.consumerPortalBaseUrl}/api/payments/receipt`, { email: this.email })
                    .then(() => {
                        this.loading = false;
                        this.sent = true;
                        this.$emit('sent', this.payment);
                    });
            },

            markAsPrimary() {
                this.loading = true;

                this.$http
                    .post(`${this.$root.$refs.app.consumerPortalBaseUrl}/api/email-addresses/mark-as-primary`, { email: this.email })
                    .then(() => {
                        this.loading = false;
                        this.modalShown = false;
                        this.close();
                    });
            },

            close() {
                this.modalShown = false;

                setTimeout(() => this.$emit('close'), 500);
            }
        }
    }
</script>
